(function () {
    'use strict';
    /* global _, $q */

    angular
        .module('surveyControllers')
        .controller('SurveyQuestionMultipleChoiceController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // Views
        $scope.view = {};
        $scope.view.showComment = false;

        // Model Init
        if (_.isUndefined($scope.question.Responses)) {
            $scope.question.Responses = [{ QuestionID: $scope.question.CampaignComponentID }];
        } else if ($scope.question.Responses.length > 1) {
            $scope.showTooManyResponsesErrorAlert();
        }
        $scope.questionResponse = _.clone($scope.question.Responses[0]);

        $scope.view.showPostmortem = $scope.questionResponse.QuestionChoiceID &&
                                     $scope.question.PostmortemEN;

        // Show Add Comment
        $scope.showAddComment = function () {
            return $scope.questionResponse.QuestionChoiceID && !$scope.showComment();
        };

        // Add comment
        $scope.addComment = function () {
            $scope.view.showComment = true;
        };

        // Show Comment
        $scope.showComment = function () {
            return $scope.questionResponse.ResponseValue || $scope.view.showComment;
        };

        // Show Optional Comment
        $scope.showOptionalComment = function () {
            return $scope.questionResponse.QuestionChoiceID === 1;
        };

        // Update Comment
        $scope.updateComment = function () {
            $scope.toAddResponse()($scope.question, $scope.questionResponse)
                .then(function (updatedResponse) {
                    $scope.questionResponse = updatedResponse;
                    $scope.questionResponse = _.clone(updatedResponse);
                });
        };

        // Update RersponseValues
        $scope.updateResponseValues = function () {
            $scope.toAddResponse()($scope.question, $scope.questionResponse)
                .then(function (updatedResponse) {
                    $scope.questionResponse = _.clone(updatedResponse);
                });
        };

        // Update Multiple Choice Response
        $scope.updateChoiceResponse = function (questionChoiceId) {

            if ($scope.view.isUpdatingAnswer === true) return;

            $scope.view.isUpdatingAnswer = true;

            if ($scope.question.IsFreeText && $scope.question.QuestionTypeCategoryBehaviour !== 'Optional') { return; }

            var responseToRemove = _.clone($scope.questionResponse);

            $scope.questionResponse.QuestionChoiceID = questionChoiceId;

            removeResponse(responseToRemove).then(function () {
                addResponse($scope.questionResponse);
            });

            $scope.showPostmortem(true);
        };

        // Show Postmortem
        $scope.showPostmortem = function (toDisplay) {
            if (toDisplay && $scope.question.PostmortemEN) {
                $scope.view.showPostmortem = toDisplay;
            }
        };

        // Is selected choice ?
        $scope.isSelectedChoice = function (choice) {
            return $scope.questionResponse.QuestionChoiceID === choice.QuestionChoiceID;
        };

        // Helpers
        function removeResponse(responseToRemove) {
            if (!responseToRemove && !responseToRemove.QuestionChoiceID) {
                $scope.question.Responses = [];
                return $q.when();
            }

            return $scope.toRemoveResponse()($scope.question, responseToRemove)
                .then(function () {
                    $scope.question.Responses = _.reject($scope.question.Responses,
                                                        { QuestionChoiceID: responseToRemove.QuestionChoiceID });
                });
        }

        function addResponse(responseToAdd) {
            return $scope.toAddResponse()($scope.question, responseToAdd)
                .then(function (addedResponse) {
                    $scope.question.Responses.push(addedResponse);
                    $scope.questionResponse = _.clone(addedResponse);

                    $scope.view.isUpdatingAnswer = false;
                });
        }
    }
})();